import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ScrollViewContainer = styled.div`
    ${media.mobileDevice`    
    max-height: ${({ maxHeight }) => (maxHeight ? maxHeight : '100vh')};
    padding-bottom: ${({ paddingBottom }) =>
        paddingBottom ? paddingBottom : 'unset'};
    overflow-y:scroll; 
          ::-webkit-scrollbar {
                width: 10px;
            }
             
            ::-webkit-scrollbar-track {
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.4); 
                border-radius: 8px;
                -webkit-border-radius: 8px;
            }
             
            ::-webkit-scrollbar-thumb {
                -webkit-border-radius: 10px;
                border-radius: 10px;
                background: rgba(100,100,100,0.8); 
                -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5); 
            }
            -webkit-overflow-scrolling: touch;
     `};
`;

export default { ScrollViewContainer };
